import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { BaseInputLayoutProps } from '../index';
import useUiTheme from '../../../uiTheme';
import { useFormContext } from 'ui-builder';
import styles from './TextAreaLayout.module.scss';
import MaxLengthInfo from './MaxLengthInfo';
import ShadcnTextAreaLayout from './ShadcnTextAreaLayout';

export interface TextAreaLayoutProps extends BaseInputLayoutProps {
  small?: boolean,
}

function LegacyTextAreaLayout(props: TextAreaLayoutProps) {
  const uiTheme = useUiTheme();

  const formContext = useFormContext();

  const maxLength = formContext.getConstraintValue
    ? formContext.getConstraintValue(props.name, 'maxLength')
    : undefined;

  return (
    <uiTheme.forms.BaseInputLayout
      name={props.name}
      label={props.label}
      errors={props.errors}
      hideLabel={props.hideLabel}
      showRequiredIcon={props.showRequiredIcon}
      className={props.className}
      hint={props.hint}
    >
      <textarea
        name={props.name}
        onChange={props.onChangeCallback}
        value={props.value || ''}
        placeholder={props.placeholder}
        disabled={props.isDisabled}
        maxLength={maxLength || undefined}
        className={props.small ? styles.small : ''}
      />
      <MaxLengthInfo name={props.name} value={props.value || ''} />
    </uiTheme.forms.BaseInputLayout>
  );
}

function TextAreaLayout(props: TextAreaLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTextAreaLayout {...props} />;
  } else {
    return <LegacyTextAreaLayout {...props} />;
  }
}

export default TextAreaLayout;
